import axios from 'axios'
import { CONFIGS } from '../config/Configs'
import { updateURL } from 'src/helpers/config'
import { jwtDecode } from 'jwt-decode'

let API = axios.create({
  baseURL: CONFIGS.API_URL.includes(CONFIGS.BASE_BACK) ? updateURL() : CONFIGS.API_URL,
})

// Variable para evitar múltiples solicitudes de renovación de token
let isRefreshing = false
let failedQueue = []

// Configurar interceptores en la instancia de Axios
API.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token')
    const refreshToken = localStorage.getItem('refresh_token')

    if (token && refreshToken) {
      const decoded = jwtDecode(token)
      const now = Date.now() / 1000
      // Si el token está cerca de expirar (por ejemplo, en los próximos 5 minutos)
              // 60   - 56 = 4 < 5
      if (decoded.exp - now < 5 && !isRefreshing) {
        isRefreshing = true

        try {
          const response = await API_LOGIN.post(
            '/auth/refresh',
            {},
            {
              headers: { Authorization: `Bearer ${refreshToken}` },
            },
          )
          const newToken = response.data.data.access_token
          localStorage.setItem('token', newToken)

          // Actualizar el token en todas las solicitudes pendientes
          failedQueue.forEach((callback) => callback(newToken))
          failedQueue = []

          config.headers.Authorization = `Bearer ${newToken}`
        } catch (error) {
          console.error('Refresh token error', error)
          // Redirigir al login si no se puede refrescar el token
        } finally {
          isRefreshing = false
        }
      } else {
        config.headers.Authorization = `Bearer ${token}`
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Interceptor para manejar respuestas de errores
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear()
      sessionStorage.clear()
      logear()
    }
    return Promise.reject(error)
  },
)

export const updateApiInstance = () => {
  API = axios.create({ baseURL: CONFIGS.API_URL })
  // Vuelve a configurar los interceptores en la nueva instancia
  API.interceptors.request.use(
    async (config) => {
      const token = localStorage.getItem('token')
      const refreshToken = localStorage.getItem('refresh_token')

      if (token && refreshToken) {
        const decoded = jwtDecode(token)
        const now = Date.now() / 1000

        if (decoded.exp - now < 5 && !isRefreshing) {
          isRefreshing = true

          try {
            const response = await API_LOGIN.post(
              '/auth/refresh',
              {},
              {
                headers: { Authorization: `Bearer ${refreshToken}` },
              },
            )
            const newToken = response.data.data.access_token
            localStorage.setItem('token', newToken)
            config.headers.Authorization = `Bearer ${newToken}`
          } catch (error) {
            console.error('Refresh token error', error)
          } finally {
            isRefreshing = false
          }
        } else {
          config.headers.Authorization = `Bearer ${token}`
        }
      }
      return config
    },
    (error) => Promise.reject(error),
  )

  API.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // Redirigir al login si el token ha expirado
        localStorage.clear()
        sessionStorage.clear()
        logear()
      }
      return Promise.reject(error)
    },
  )
}

export const API_LOGIN = axios.create({ baseURL: CONFIGS.LOGIN_URL })

// Configurar interceptores en la instancia de Axios
API_LOGIN.interceptors.request.use(
  async (config) => {
    if (!config.url.includes('/login')) {
      const token = localStorage.getItem('token')
      const refreshToken = localStorage.getItem('refresh_token')

      if (token && refreshToken) {
        const decoded = jwtDecode(token)
        const now = Date.now() / 1000

        if (decoded.exp - now < 5 && !isRefreshing) {
          isRefreshing = true

          try {
            const response = await API_LOGIN.post(
              '/auth/refresh',
              {},
              {
                headers: { Authorization: `Bearer ${refreshToken}` },
              },
            )
            const newToken = response.data.data.access_token
            localStorage.setItem('token', newToken)
            config.headers.Authorization = `Bearer ${newToken}`
          } catch (error) {
            console.error('Refresh token error', error)
          } finally {
            isRefreshing = false
          }
        } else {
          config.headers.Authorization = `Bearer ${token}`
        }
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

API_LOGIN.interceptors.response.use(
  (response) => response,
  (error) => {
    // Manejar errores en la respuesta
    if (error.response && error.response.status === 401) {
      // Por ejemplo, redirigir al usuario a la página de login
      localStorage.clear()
      sessionStorage.clear()
      logear()
    }
    return Promise.reject(error)
  },
)

export const config = (token) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  }
}

const logear = () => {
  window.location.href = '/login'
}

export { API }
